/**
 * Tab type
 * @param {string|number} id - ID
 * @param {string|object} params - Parameters
 * @param {string} params.tab - Tab href
 * @param {string} params.name - Tab Name
 * @param {string} params.value - Tab Value
 * @param {string} params.icon - Tab Icon
 * @param {object} params.to - Tab route
 * @param {boolean} params.exact - Tab route exact match
 */
export default function (id, params) {
	const myParams = typeof params === 'object' ? params : {}

	// params = { tab, name, value, icon, to, exact }
	let {
		tab, name, value,
	} = myParams
	const {
		icon, to, exact, disabled,
	} = myParams

	if (typeof params === 'string') {
		tab = id
		name = params
		value = id
	}

	this.id = id
	this.tab = tab || null
	this.name = name || null
	this.icon = icon || null
	this.to = to || null
	this.disabled = disabled || false
	this.exact = exact || null
	this.value = value || null
}
